module.exports = __webpack_public_path__ + "static/img/1.62a9ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/colorpop/1.jpg
// module id = M41w
// module chunks = 1